
import {
    SET_TAX_RULES,
    SET_TAX_RULES_LOADING,
    SET_CREATE_TAX_RULE_LOADING,
    SET_UPDATE_TAX_RULE_LOADING,
    SET_DELETE_TAX_RULE_LOADING,
} from "../../../actions/SocietyPortal/TaxRuleAction/TaxRuleAction";

const initialState = {
    taxRulesData: [],
    loading: false,
    createLoading: false,
    updateLoading: false,
    deleteLoading: false,
    error: null,
};

const TaxRuleReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_TAX_RULES:
            return {
                ...state,
                taxRulesData: action.payload,
                loading: false,
                error: null,
            };
        case SET_TAX_RULES_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case SET_CREATE_TAX_RULE_LOADING:
            return {
                ...state,
                createLoading: action.payload,
            };
        case SET_UPDATE_TAX_RULE_LOADING:
            return {
                ...state,
                updateLoading: action.payload,
            };
        case SET_DELETE_TAX_RULE_LOADING:
            return {
                ...state,
                deleteLoading: action.payload,
            };
        default:
            return state;
    }
};

export default TaxRuleReducer;
